import create from 'zustand'

type PaymentMethod =
  | 'CARTAO_CREDITO'
  | 'CARTAO_DEBITO'
  | 'PICPAY'
  | 'AME'
  | 'BOLETO'
  | 'CONSULTA_GRATIS'

type AttendancePaymentType = {
  attendancePayment: PaymentMethod
  setAttendancePayment: (attendancePaymentMethod) => void
}

export const useAttendancePaymentMethod = create<AttendancePaymentType>(
  set => ({
    attendancePayment: null,
    setAttendancePayment: (attendancePayment: PaymentMethod) => {
      set(() => ({
        attendancePayment,
      }))
    },
  }),
)
